<template>
  <div :style="css">
    <Loading v-if="loading" />

    <v-sheet
      v-else-if="item.hours && item.reports"
      color="#FAFAFA"
      class="py-10 py-sm-12 py-md-14 py-lg-16 overflow-hidden"
    >
      <v-container>
        <PagesTitle logoHeight="24px" :mod="mod">Horários</PagesTitle>

        <v-row justify="center" class="mx-0 mx-sm-n3 mt-10">
          <v-col cols="12" lg="10">
            <v-row justify="center" class="relative items">
              <img src="/img/bg/vertical.png" class="bg-vertical" />
              <img src="/img/bg/horizontal.png" class="bg-horizontal" />
              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  align-start
                  page-color-primary
                  px-5
                  py-8 py-sm-10 py-md-16
                  relative
                  item
                "
                height="100%"
              >
                <div class="relative mt-n3">
                  <v-icon color="white" size="58"> far fa-clock </v-icon>
                </div>

                <div class="ml-5 relative item-caption py-5">
                  <div
                    class="
                      white--text
                      text-h5 text-md-h4
                      font-weight-medium
                      item-title
                    "
                  >
                    Horários
                    <v-sheet color="white" width="40px" height="2px"></v-sheet>
                  </div>

                  <div
                    v-html="item.hours"
                    class="text-caption white--text item-text mt-5"
                  ></div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  align-center
                  justify-center
                  page-color-secondary
                  lighten-2
                  px-5
                  py-md-16 py-10
                  relative
                  item
                "
                height="100%"
              >
                <div class="item-caption px-5 px-md-16">
                  <div
                    v-html="reportsHtml"
                    class="
                      text-md-h4 text-h6
                      font-weight-medium
                      item-text
                      text-color-primary text-center
                    "
                  ></div>
                  <div class="mt-4 d-flex">
                    <v-btn
                      v-if="item.whatsapp"
                      :href="getWhatsappLinkFromPhone(item.whatsapp)"
                      height="44px"
                      depressed
                      color="page-color-primary"
                      class="white--text px-5 text-none rounded-lg"
                      target="_blank"
                    >
                      <v-icon>fa-whatsapp</v-icon>
                      <span class="ml-2 text-body-1">{{ item.whatsapp }}</span>
                    </v-btn>
                    <v-btn
                      v-if="item.phone"
                      :href="getTelLinkFromPhone(item.phone)"
                      height="44px"
                      depressed
                      color="page-color-primary"
                      class="white--text px-5 text-none rounded-lg ml-4"
                      target="_blank"
                    >
                      <v-icon>fas fa-phone-alt</v-icon>
                      <span class="ml-2 text-body-1">{{ item.phone }}</span>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { getTelLinkFromPhone } from "../../utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import Loading from "../widgets/Loading.vue";
import PagesTitle from "../widgets/PagesTitle.vue";

const _config = {
  mod: "pages-informations-contacts",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    item: {},
  }),
  computed: {
    css() {
      return {
        "--page-color-primary": this.colors[0],
        "--page-color-secondary": this.colors[1],
      };
    },
    reportsHtml() {
      const stringSplited = this.item.reports.split("<br>");
      if (stringSplited.length) {
        return `${stringSplited[0]}<span class="font-weight-bold text-h4 text-sm-h3 text-md-h2">${stringSplited[1]}</span>`;
      }
      return this.item.reports;
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
    getTelLinkFromPhone,
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.page-color-primary {
  background-color: var(--page-color-primary) !important;
}
.text-color-primary {
  color: var(--page-color-primary) !important;
}
.page-color-secondary {
  background-color: var(--page-color-secondary) !important;
}
.items {
  .bg-horizontal {
    position: absolute;
    right: -30px;
    top: -30px;
  }

  .bg-vertical {
    bottom: -30px;
    left: -30px;
    position: absolute;
  }

  .item {
    &:nth-child(odd) {
      border-radius: 18px 0 0 18px;
      @media screen and (max-width: 960px) {
        border-radius: 18px 18px 0 0;
      }
    }

    &:nth-child(even) {
      border-radius: 0 18px 18px 0;
      @media screen and (max-width: 960px) {
        border-radius: 0 0 18px 18px;
      }
    }
  }
}
</style>
